import { SiteSelect } from "components/form/SiteSelect";
import { UserSelect } from "components/form/UserSelect";
import EnhancedDateSelect from "components/general/EnhancedDateSelect";
import { Box, Button, CloseIcon, Input, InputField, InputIcon, InputSlot, Pressable, Select, Typography } from "components/ui";
import CheckBox from "expo-checkbox";
import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { useIsMobile } from "utils/hooks/useIsMobile";

type Props = {
	onSiteChange: (groupIdCollection: number[]) => void;
	onOrderByChange: (siteIdCollection: number[]) => void;
	onDateChange: (dates: any) => void;
	onOrderTypeChange: (orderType: string) => void;
	onSearchFilterChange: (searchFilter: string) => void;
	onShowAwaitingApproval: (value: boolean) => void;
	startDate?: Date | null;
	endDate?: Date | null;
	orderType?: string;
};

const OrdersFilter = ({ onSiteChange, onOrderByChange, onDateChange, onOrderTypeChange, onSearchFilterChange, onShowAwaitingApproval, startDate, endDate, orderType: initialOrderType }: Props) => {
	const isMobile = useIsMobile();
	const [onlyOrdersAwaitingApproval, setOnlyOrdersAwaitingApproval] = React.useState(false);
	const [orderType, setOrderType] = React.useState<string>(initialOrderType || "");
	const [searchFilter, setSearchFilter] = React.useState("");

	React.useEffect(() => {
		if (initialOrderType) {
			setOrderType(initialOrderType);
		}
	}, [initialOrderType]);

	const orderTypeOptions = [
		{ value: "salesorder", label: "Sales Order" },
		{ value: "cart", label: "Cart" },
	];

	const handleOrderTypeChange = (value: string) => {
		setOrderType(value);
		onOrderTypeChange(value);
	};

	const handleSearchFilterChange = (value: any) => {
		setSearchFilter(value);
		onSearchFilterChange(value);
	};
	const handleShowAwaitingApproval = (value: any) => {
		setOnlyOrdersAwaitingApproval(value);
		onShowAwaitingApproval(value);
	};

	return (
		<GridContainer
			noPadding
			style={{
				marginLeft: 0,
				maxWidth: "100%",
				// marginBottom: 66,
				gap: 24,
				zIndex: 9,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
		>
			<Row style={{ gap: isMobile ? 12 : 0, position: "relative", zIndex: 10 }}>
				<Col xs={12} md={4}>
					<Box zIndex={2} bg="$basicwhite" borderRadius={12}>
						<Typography
							sx={{
								top: isMobile ? -11 : 0,
								position: "absolute",
								zIndex: 1,
								lineHeight: 1.5,
								left: 11,
								background: "white",
								paddingLeft: 6,
								fontSize: 13,
								fontWeight: 700,
								paddingRight: 6,
							}}
						>
							Filter by keywords:
						</Typography>
						<Input flex={1} px="$0" borderWidth={1} borderColor="$neutral300" borderRadius={12} py="$3" isDisabled={false} isInvalid={false} isReadOnly={false} isFocused={true} isHovered={true}>
							<InputField borderWidth={0} fontSize={16} borderRadius={"$lg"} placeholder={"Type here..."} value={searchFilter} onChangeText={handleSearchFilterChange} color="$basicblack" placeholderTextColor={"#cccccc"} />
							<InputSlot>
								{searchFilter.length > 0 && (
									<Pressable
										onPress={() => {
											handleSearchFilterChange("");
										}}
									>
										<InputIcon as={CloseIcon} mr="$4" color={"$textLight400"} />
									</Pressable>
								)}
							</InputSlot>
						</Input>
					</Box>
				</Col>
				<Col md={4}>
					<Box position="relative" marginBottom={16} bg="$basicwhite" borderRadius={12}>
						<Typography
							sx={{
								top: isMobile ? -11 : 0,
								position: "absolute",
								zIndex: 1,
								lineHeight: 1.5,
								left: 11,
								background: "white",
								paddingLeft: 6,
								fontSize: 13,
								fontWeight: 700,
								paddingRight: 6,
							}}
						>
							Filter by date:
						</Typography>
						<EnhancedDateSelect isDateRange={true} onDateChange={onDateChange} initialStartDate={startDate || undefined} initialEndDate={endDate || undefined} />
					</Box>
					{/* <Select label="Select emoji" value={""} options={dummyOptions} onChange={() => {}} /> */}
				</Col>
				<Col xs={12} md={4}>
					<SiteSelect isLight isMulti={true} onSelect={(values) => onSiteChange(values.map((e: any) => e.id))} title="Filter by site" />
				</Col>
			</Row>
			<Row style={{ gap: isMobile ? 12 : 0, alignItems: "center", position: "relative", zIndex: 9 }}>
				<Col xs={12} md={4}>
					<Select label="Order Types" options={orderTypeOptions} value={orderTypeOptions.find((option) => option.value === orderType) || null} onChange={handleOrderTypeChange} />
				</Col>
				<Col md={4}>
					<UserSelect
						onSelect={(userCollection) => {
							onOrderByChange(userCollection.map((user: any) => user.id));
						}}
						label="Ordered by"
						placeholder="Supervisor/manager"
					/>
				</Col>
				<Col xs={12} md={4}>
					<Button onPress={() => handleShowAwaitingApproval(!onlyOrdersAwaitingApproval)} justifyContent="flex-start" paddingHorizontal={0} gap={4} alignItems="center">
						<CheckBox color={"#2B6FBB"} value={onlyOrdersAwaitingApproval} />
						<Typography>Only show orders awaiting my approval</Typography>
					</Button>
				</Col>
			</Row>
		</GridContainer>
	);
};

export default OrdersFilter;
